export const CLUSTER_TYPE_ENUM = {
  "hadoop": { text: "Hadoop" },
  "mysql": { text: "MySQL" },
};

export const REGIONS_ENUM = {
  "us-east-1": { text: "us-east-1" },
  "us-east-2": { text: "us-east-2" },
  "ap-south-1": { text: "ap-south-1" },
  "ap-northeast-1": { text: "ap-northeast-1" },
  "eu-west-1": { text: "eu-west-1" },
};

export const REGIONS_ZONE_ENUM = {
  "us-east-1": {
    "us-east-1-AZ-1": { text: "us-east-1-AZ-1" },
    "us-east-1-AZ-2": { text: "us-east-1-AZ-2" },
    "us-east-1-AZ-3": { text: "us-east-1-AZ-3" },
  },
  "us-east-2": {
    "us-east-2-AZ-1": { text: "us-east-2-AZ-1" },
    "us-east-2-AZ-2": { text: "us-east-2-AZ-2" },
  },
  "ap-south-1": {
    "ap-south-1-AZ-A": { text: "ap-south-1-AZ-A" },
    "ap-south-1-AZ-B": { text: "ap-south-1-AZ-B" },
  },
  "ap-northeast-1": {
    "ap-northeast-1-AZ-F": { text: "ap-northeast-1-AZ-F" },
    "ap-northeast-1-AZ-S": { text: "ap-northeast-1-AZ-S" },
  },
  "eu-west-1": {
    "eu-west-1-AZ-A": { text: "eu-west-1-AZ-A" },
    "eu-west-1-AZ-B": { text: "eu-west-1-AZ-B" },
  },
};